module.exports = __webpack_public_path__ + "static/media/msf-logo.61afc9f7.png";